import React from 'react'
import { ResponsiveBar } from '@nivo/bar'
import withWidth from '@material-ui/core/withWidth';
import { detect } from 'detect-browser'
import colors from '../../constants/colors'

import {
  format_number
} from '../../helpers'

class Bar extends React.Component {
  // props:
  // headers: ["h1", "h2"]
  // data: server sent it to me :)
  state = {
    showXbar: false,
    xbarInterval: null
  }

  componentWillUnmount() {
    if (this.state.xbarInterval) {
      window.clearInterval(this.state.xbarInterval)
      this.setState({
        showXbar: false,
        xbarInterval: null
      })
    }
  }

  componentWillMount() {
    const setState = this.setState.bind(this)
    this.setState({
      xbarInterval: window.setInterval(function(){
        setState({showXbar: true})
      }, 1000)
    })
  }

  componentDidUpdate(prevState, prevProps) {
    const setState = this.setState.bind(this)
    if ( this.state.showXbar === false ) {
      setTimeout( function() {
        setState({showXbar: true})
      }, 500)
    }
  }

  render() {
    const { headers, forceFirstColors } = this.props

    const matches = this.props.match || {}

    const graph_headers = headers.map( h => {
      return matches[h] || h
    })

    const data = this.props.graphData

    const graph_data = data.map( item => {
      let ret_data = {}
      headers.forEach( h=> {
        const lab = matches[h] || h
        ret_data[lab] = item[h]
      })
      return ret_data
    })

    const browser = detect();
    const changePaddings = (browser.name === 'chrome' || browser.name === 'ios')
    const rotation = this.props.rotateOnSmall === true && (this.props.width === 'sm' || this.props.width === 'xs') ? -45 : 0
    const marginBottom = this.props.rotateOnSmall === true && (this.props.width === 'sm' || this.props.width === 'xs') ? 150 : 80
    const bottomPadding = this.props.rotateOnSmall === true && (this.props.width === 'sm' || this.props.width === 'xs') ? 25 : changePaddings ? 4 : 12
    const bottomOffset = this.props.rotateOnSmall === true && (this.props.width === 'sm' || this.props.width === 'xs') ? 20 : 36
    const legendBottom = this.props.rotateOnSmall === true && (this.props.width === 'sm' || this.props.width === 'xs') ? 140 : 80
    const legendLeft = this.props.rotateOnSmall === true && (this.props.width === 'sm' || this.props.width === 'xs') ? -50 : -20
    const marginRight  = (this.props.width === 'sm' || this.props.width === 'xs') ? 5 : 40

    // const colorMatch = {
    //   'Coupon': '#1d78b4',
    //   'Fully Paid': '#a6cee3',
    //   'Published': '#c6dbef',
    //   'All': '#deebf7',
    //   'Draft': '#deebf7',
    //   'Trashed': '#f7fbff"'
    // }
    const colorMatch = {
      'Coupon': '#9467bd',
      'Fully Paid': '#1f77b4',
      'Published': '#2ea02c',
      'All': '#2ea02c',
      'Draft': '#7f7f7f',
      'Trashed': '#d62728"'
    }
    const tooltip = item => {
      const { id, value, color, data } = item
      const total = Object.keys(data).filter(d => d!=="label").map(d => data[d]).reduce((a,b) => a+b)
      const useColor = colorMatch[id] || color
      const displayValue = format_number(value, false)
      const percent = total > 0 ? Math.round((value * 100)/total) : 0
      return (
        <div style={{whiteSpace: 'pre', display: 'flex', alignItems: 'center'}}>
          <span style={{
            display: 'block', width: 12, height: 12, background: `${useColor} none repeat scroll 0% 0%`, marginRight: 7
          }}></span>
          <span>{id}: <strong>{displayValue}</strong> ({percent} %)</span>
        </div>
      )
    }

    return(
      <ResponsiveBar
        tooltip={tooltip}
        labelFormat={v => format_number(v, false)}
        data={graph_data}
        indexBy="label"
        colors={forceFirstColors ? [...forceFirstColors, ...colors] : colors}
        keys={graph_headers}
        padding={0.3}
        margin={{
          "top": 28,
          "right": marginRight,
          "bottom": marginBottom,
          "left": 60
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={this.state.showXbar ? {
          "tickSize": 4,
          "tickPadding": bottomPadding,
          "tickRotation": rotation,
          "legend": this.props.xaxis || "",
          "legendOffset": bottomOffset,
          "legendPosition": "middle"
        } : null}
        axisLeft={{
          "tickSize": 5,
          "tickPadding": 5,
          "tickRotation": 0,
          "legend": this.props.yaxis || "",
          "legendOffset": -40,
          "legendPosition": "middle"
        }}
        borderWidth={0.5}
        borderColor="rgba(0,0,0,0.87)"
        labelSkipHeight={14}
        labelTextColor={"#ffffff" /* this.props.color === 'bright' ? "inherit:brighter(2)" : "inherit:darker(1.6)" */ }
        animate={true}
        motionStiffness={90}
        motionDamping={15}
        defs={[
          {
            "id": "published",
            "type": "patternDots",
            "background": "#2ea02c",
            "color": "#2ea02c",
            "size": 4,
            "padding": 1,
            "stagger": true
          },
          {
            "id": "draft",
            "type": "patternDots",
            "background": "#7f7f7f",
            "color": "#7f7f7f",
            "size": 4,
            "padding": 1,
            "stagger": true
          },
          {
            "id": "trash",
            "type": "patternDots",
            "background": "#d62728",
            "color": "#d62728",
            "size": 4,
            "padding": 1,
            "stagger": true
          },
          {
            "id": "paid",
            "type": "patternDots",
            "background": "#1f77b4",
            "color": "#1f77b4",
            "size": 4,
            "padding": 1,
            "stagger": true
          },
          {
            "id": "coupons",
            "type": "patternDots",
            "background": "#9467bd",
            "color": "#9467bd",
            "size": 4,
            "padding": 1,
            "stagger": true
          },
        ]}
        fill={[
          {
            "match": { "id": "Published" },
            "id": "published"
          },
          {
            "match": { "id": "Draft" },
            "id": "draft"
          },
          {
            "match": { "id": "Trashed" },
            "id": "trash"
          },
          {
            "match": { "id": "Trash" },
            "id": "trash"
          },
          {
            "match": { "id": "Coupon" },
            "id": "coupons"
          },
          {
            "match": { "id": "Fully Paid" },
            "id": "paid"
          },
        ]}
        theme={{
          axis: {ticks: {text: { fill: "#6A7C89"}}}
        }}
        legends={[{
          "dataFrom": "keys",
          "anchor": "bottom-left",
          "direction": "row",
          "justify": false,
          "translateX": legendLeft,
          "translateY": legendBottom,
          "itemsSpacing": 0,
          "itemDirection": "left-to-right",
          "itemWidth": 80,
          "itemHeight": 20,
          "itemOpacity": 1,
          "symbolSize": 12,
          "symbolShape": "circle",
          "symbolBorderColor": "#000000",
          "effects": [
            {
              "on": "hover",
              "style": {
                "itemBackground": "rgba(0, 0, 0, .03)",
                "itemOpacity": 1
              }
            }
          ]
        }]}
      />
    )
  }
}

export default withWidth()(Bar)



// WEBPACK FOOTER //
// ./src/js/components/graphs/ResponsiveBar.js